import { render, staticRenderFns } from "./ImportacaoTabelaPrecos.vue?vue&type=template&id=19f148ee&scoped=true"
import script from "./ImportacaoTabelaPrecos.vue?vue&type=script&lang=js"
export * from "./ImportacaoTabelaPrecos.vue?vue&type=script&lang=js"
import style0 from "./ImportacaoTabelaPrecos.vue?vue&type=style&index=0&id=19f148ee&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f148ee",
  null
  
)

export default component.exports